import { render } from "./OneOnOneListPlaceholder.vue?vue&type=template&id=441538b1&scoped=true"
import script from "./OneOnOneListPlaceholder.vue?vue&type=script&lang=js"
export * from "./OneOnOneListPlaceholder.vue?vue&type=script&lang=js"

import "./OneOnOneListPlaceholder.vue?vue&type=style&index=0&id=441538b1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-441538b1"

export default script